const empty = {};
export const getTitles = (store) => {
	return store.Session.fetchTitles?.data?.entity?.titles || empty;
};
